// extracted by mini-css-extract-plugin
module.exports = {"container":"offer-status_container_1owZ6","badge":"offer-status_badge_1_Pwb"};